import {Component} from "@angular/core";
import {InventoryEntityModel} from "../../inventory-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-inventory-edit-barcode",
    templateUrl: "./inventory-edit-barcode.component.html"

})
export class InventoryEditBarcodeComponent {
    constructor(public model: InventoryEntityModel, public editService: EditService) {

    }
}
